import type { TranslationTree } from '../../types';

export const profile: TranslationTree = {
  profile: {
    hero: {
      badge: 'Espace personnel',
      title: 'Bienvenue, {{name}}',
      subtitle: 'Personnalisez votre expérience ToolLife et sécurisez vos accès.',
      emailLabel: 'Adresse e-mail',
      anonymous: 'utilisateur',
    },
    overview: {
      title: 'Profil et accès',
      description: 'Informations liées à votre compte et modules actifs.',
      emailLabel: 'Adresse de connexion',
      emailFallback: 'Non renseignée',
      modulesTitle: 'Modules activés',
      modulesHelper: 'Ces accès déterminent les fonctionnalités disponibles.',
      modulesCount: '{{count}} module(s) actif(s)',
      modulesEmpty: "Aucun module n'est actuellement activé pour votre compte.",
    },
    modules: {
      chip: {
        traceability: 'Traçabilité',
        analytics: 'Analyses avancées',
        machineLearning: 'Maintenance prédictive',
      },
    },
    preferences: {
      title: "Préférences d'interface",
      description: "Adaptez l'apparence et la langue de l'application.",
      themeLabel: 'Thème',
      languageLabel: 'Langue',
    },
    security: {
      title: 'Sécurité du compte',
      description: 'Mettez à jour votre mot de passe et protégez vos identifiants.',
    },
    password: {
      title: 'Modifier le mot de passe',
      fields: {
        current: {
          label: 'Mot de passe actuel',
          placeholder: 'Saisir le mot de passe actuel',
        },
        new: {
          label: 'Nouveau mot de passe',
          placeholder: 'Définir un nouveau mot de passe',
        },
        confirm: {
          label: 'Confirmer le mot de passe',
          placeholder: 'Confirmer le nouveau mot de passe',
        },
      },
      actions: {
        submit: 'Enregistrer le nouveau mot de passe',
        submitting: 'Enregistrement…',
      },
      status: {
        success: 'Votre mot de passe a été mis à jour.',
      },
      errors: {
        mismatch: 'Le nouveau mot de passe et sa confirmation ne correspondent pas.',
        default: 'Impossible de mettre à jour le mot de passe.',
        client: 'Session utilisateur introuvable. Veuillez vous reconnecter.',
      },
    },
  },
};
